import {Component, Input} from "@angular/core";
import {InputBaseComponent} from "../../base/input-base.component";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

enum InputTypes{
  TEXT = 'text',
  NUMBER = 'number',
}


@Component({
  selector: "tva-input",
  templateUrl: "./tv-action-input.component.html",
  styleUrls: ["./tv-action-input.component.scss"],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: TvActionInputComponent,
    multi: true
  }]
})
export class TvActionInputComponent extends InputBaseComponent{
  @Input() label;
  @Input() placeholder;
  @Input() maxlength: number;
  @Input() editable = true;
  @Input() type = InputTypes.TEXT;

  constructor() {
    super();
  }

  onKeyPressed($event: KeyboardEvent): void{
    if(this.isNumberInput()){
      if(this.maxlength && this.formControl.value?.length == this.maxlength){
        $event.preventDefault();
      }
    }
  }

  onPaste($event: ClipboardEvent): void{
    if(this.isNumberInput())
      if ((this.formControl.value + $event.clipboardData.getData('text')).length > this.maxlength) {
        $event.preventDefault();
      }
  }

  private isNumberInput(): boolean{
    return this.type === InputTypes.NUMBER;
  }
}
